import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useKeywordSearchParam, useTypedSearchParams } from '@/hook';
import { DeveloperBoard, VButton, VFlex, VInput, VSelect } from '@/package';
import type { ModelingListSearchParams } from '@/type';

const ModelingPageHeader = () => {
  const { t } = useTranslation();
  const { get, set, flush } = useTypedSearchParams<ModelingListSearchParams>();
  const { keyword, onKeywordChange } = useKeywordSearchParam({
    searchParamKey: 'modelingKeyword',
  });
  const limit = get('modelingLimit') as string;
  const setLimit = (value: number) => {
    set('modelingLimit', `${value}`);
    flush();
  };
  const navigate = useNavigate();

  const limitListRef = useRef([
    {
      label: t('common.showItemNum.creatine', {
        itemNum: 20,
      }),
      value: '20',
    },
    {
      label: t('common.showItemNum.creatine', {
        itemNum: 10,
      }),
      value: '10',
    },
  ]);

  return (
    <VFlex className="py-4" justify="between" items="center">
      <VInput
        placeholder={t('development.searchInputPlaceholder.photopile')}
        type="search"
        value={keyword}
        onChange={onKeywordChange}
      />

      <VFlex items="center" gap={1}>
        <VSelect
          className="w-[104px]!"
          // eslint-disable-next-line react-hooks/refs
          itemList={limitListRef.current}
          size="lg"
          value={limit}
          onChange={event => setLimit(event.target.value)}
        />

        <VFlex items="center" gap={0.5}>
          <VButton size="lg" onClick={() => navigate('/modeling/training')}>
            <DeveloperBoard />
            {t('modeling.modelTraining.moksha')}
          </VButton>
        </VFlex>
      </VFlex>
    </VFlex>
  );
};

export default ModelingPageHeader;
